import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TrendingCard.css';

const TrendingCard = ({ product }) => {
    const discount = product.discount || (product.originalPrice ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100) : 0);

    return (
        <Link to={`/product/${product.id}`} className="trending-card">
            <div className="trending-image-container">
                <img
                    src={product.images && product.images.length > 0 ? product.images[0] : product.image}
                    alt={product.name}
                    className="trending-image"
                />
                <div className="trending-overlay">
                    <div className="trending-content">
                        {discount > 0 && <h3 className="trending-discount">{discount}% OFF</h3>}
                    </div>
                </div>
            </div>
            <div className="trending-brand-pill">
                <span>{product.brand || product.seller || 'India Crafts'}</span>
            </div>
        </Link>
    );
};

export default TrendingCard;
